module.exports = __webpack_public_path__ + "components/breadcrumbs/static/home-a53fcbde33d90e78ac8eff93c071ac84.svg";